import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=5befdfcd&scoped=true"
import script from "./Item.vue?vue&type=script&lang=ts"
export * from "./Item.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5befdfcd",
  null
  
)

export default component.exports